module.exports = __webpack_public_path__ + "media/images/admin/dashboard-estates-25940d993d6f19515f049825e77d638f.jpg";